import { gql } from '@apollo/client';

export const EMAIL_TEMPLATES_LIST = gql`
  query EmailTemplatesList {
    emailTemplatesList {
      items {
        id
        name
        subject
        body
        category
        isActive
        description
        createdAt
        updatedAt
      }
    }
  }
`;

export const EMAIL_TEMPLATE_GET = gql`
  query EmailTemplateGet($id: ID!) {
    emailTemplate(id: $id) {
      id
      name
      subject
      body
      category
      isActive
      description
      createdAt
      updatedAt
    }
  }
`;

export const EMAIL_TEMPLATE_GET_BY_USE_CASE = gql`
  query EmailTemplateGetByUseCase($category: String!) {
    emailTemplatesList(filter: { category: { equals: $category }, isActive: { equals: true } }) {
      items {
        id
        name
        subject
        body
        category
        isActive
        description
      }
    }
  }
`;

// Specific query for template ID 1126 (add_employee_to_policy)
export const EMAIL_TEMPLATE_GET_BY_ID_1126 = gql`
  query EmailTemplateGetById1126 {
    emailTemplate(id: "1126") {
      id
      name
      subject
      body
      category
      isActive
      description
      createdAt
      updatedAt
    }
  }
`;

export const EMAIL_TEMPLATE_CREATE = gql`
  mutation EmailTemplateCreate($data: EmailTemplateCreateInput!) {
    emailTemplateCreate(data: $data) {
      id
      name
      subject
      body
      category
      isActive
    }
  }
`;

export const EMAIL_TEMPLATE_UPDATE = gql`
  mutation EmailTemplateUpdate($filter: EmailTemplateKeyFilter!, $data: EmailTemplateUpdateInput!) {
    emailTemplateUpdate(filter: $filter, data: $data) {
      id
      name
      subject
      body
      category
      isActive
    }
  }
`;

export const EMAIL_TEMPLATE_DELETE = gql`
  mutation EmailTemplateDestroy($filter: EmailTemplateKeyFilter!) {
    emailTemplateDestroy(filter: $filter) {
      success
    }
  }
`;
